import {
  type PhysicalWarehouseListItem,
  type WarehouseModel,
  getPhysicalWarehouseList,
  getWarehouseList,
} from '@/api/common'
import { notificationListApi, showlistApi, type NotifyListPageParams } from '@/api/tools'
import { useLocale } from './useLocale'
export default function useCommonDataSource() {
  const { locale } = useLocale()
  const isChina = ['zh_CN', 'zh_TW'].includes(locale.value)

  const getPhysicalWarehouses = async (data: {
    regionWarehouseCode: string
  }): Promise<PhysicalWarehouseListItem[]> => {
    try {
      const { list } = await getPhysicalWarehouseList(data)
      return list.map((item) => ({
        ...item,
        physicsWarehouseName: isChina ? item.physicsWarehouseNameCn : item.physicsWarehouseNameEn,
      }))
    } catch (err) {
      return []
    }
  }

  const getLogicWarehouses = async (): Promise<WarehouseModel[]> => {
    try {
      const { records } = await getWarehouseList()
      return records.map((item) => ({
        ...item,
        regionWarehouseName: isChina ? item.regionWarehouseNameCn : item.regionWarehouseNameEn,
      }))
    } catch (err) {
      return []
    }
  }

  const getNotificationListApi = async (data: NotifyListPageParams) => {
    try {
      const { records, total } = await notificationListApi(data)
      const list = records.map((item) => ({
        ...item,
        title: isChina ? item.titleZh : item.titleEn,
        content: isChina ? item.contentZh : item.contentEn,
        total,
      }))
      return { records: list, total }
    } catch (err) {
      return { records: [], total: 0 }
    }
  }

  const getNotificationListByModalApi = async (data: { msgMode: number }) => {
    try {
      const records = await showlistApi(data)
      return records.map((item) => ({
        ...item,
        title: isChina ? item.titleZh : item.titleEn,
        content: isChina ? item.contentZh : item.contentEn,
      }))
    } catch (err) {
      return []
    }
  }

  return {
    getPhysicalWarehouses,
    getLogicWarehouses,
    getNotificationListApi,
    getNotificationListByModalApi,
  }
}
